import { ConnectedBeam } from '@/components/shared/ConnectedBeam';
import { SocialConnectDialog } from '@/components/shared/SocialConnectDialog';
import { RainbowButton } from '@/components/ui/rainbow-button';

export const OnboardingSocial = () => {
  return (
    <div className="container mx-auto px-10 py-[5vh]">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
        <div>
          <h1 className="text-[42px] font-medium mb-4 text-balance max-w-3xl mx-auto tracking-tighter lg:mx-0">
            Connect Your Socials
          </h1>
          <p className="text-muted-foreground max-w-[600px] mx-auto lg:mx-0">
            Unlock the full potential of Clue Labs by connecting your social
            accounts. Get access to powerful analytics, automated insights, and
            seamless social media management tools designed to help your
            business grow.
          </p>
          <div className="flex justify-center lg:justify-start mt-10">
            <SocialConnectDialog>
              <RainbowButton>Connect Socials</RainbowButton>
            </SocialConnectDialog>
          </div>
        </div>
        <ConnectedBeam />
      </div>
    </div>
  );
};
